/* ClipDockBar — collapsed clipboard dock row.
 *
 * A single flex row: [clipboard icon][tap-region (flex:1)][Copy][Send].
 * The tap region grows and clips its overflowing preview to an ellipsis.
 * `[data-pulsing]` runs a brief accent-tinted background pulse the host
 * toggles when a fresh clip arrives. */

.bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-8);
  padding: var(--spacing-8) var(--spacing-12);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  background: var(--bg-secondary);
}

.tapRegion {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  align-items: flex-start;
  padding: var(--spacing-4);
  margin: calc(-1 * var(--spacing-4));
  border: none;
  background: none;
  border-radius: var(--radius-8);
  cursor: pointer;
  text-align: left;
}

.tapRegion:hover {
  background: var(--bg-tertiary);
}

.preview {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font: var(--text-micro-regular);
  color: var(--text-secondary);
}

.meta {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@keyframes clip-dock-pulse {
  0% {
    background: var(--brand);
  }
  100% {
    background: var(--bg-secondary);
  }
}

.bar[data-pulsing] {
  animation: clip-dock-pulse 600ms ease-out;
}
